import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=073fc79a&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073fc79a",
  null
  
)

export default component.exports